'use client';

import React, { useState, useEffect } from 'react';

import { Carousel } from '@/components/molecules';
import TabItem from '@/components/molecules/TabItem';

import { TabsProps } from './types';

export const Tabs: React.FC<TabsProps> = ({
  tabs,
  onTabChange,
  initialActiveKey,
}) => {
  const [activeKey, setActiveKey] = useState<string>(
    initialActiveKey || tabs[0]?.key,
  );
  const [isMobile, setIsMobile] = useState(true);
  const [hasMounted, setHasMounted] = useState(false);
  const checkWidth = () => setIsMobile(window.innerWidth < 660);

  useEffect(() => {
    checkWidth();
    window.addEventListener('resize', checkWidth);
    setHasMounted(true);
    return () => window.removeEventListener('resize', checkWidth);
  }, []);

  const handleTabClick = (key: string) => {
    setActiveKey(key);
    onTabChange?.(key);
  };

  if (!hasMounted) return null;

  return (
    <Carousel
      autoplay={false}
      navigation={isMobile}
      pagination={false}
      spaceBetween={10}
      type="tabs"
      justifyContent="flex-start"
      width="!w-auto"
    >
      {tabs.map(tab => (
        <TabItem
          key={tab.key}
          icon={tab.icon}
          label={tab.label}
          isActive={activeKey === tab.key}
          onClick={() => handleTabClick(tab.key)}
        />
      ))}
    </Carousel>
  );
};
